export const V2_SIDEBAR_WIDTH_PX = 224;
export const V2_SIDEBAR_WIDTH_COLLAPSED_PX = 72;
export const HOMEPAGE_PATHS = [
  '/',
  '/learn',
  '/governance',
  '/developers',
  '/community',
  '/mission',
  '/roadmap',
];
